<span>
  {{ ("CAMERA_GROUP" | translate) + " " }}

  <a [routerLink]="['/camera-configuration', $safeNavigationMigration(log?.details?.targetId)]" (click)="closeDialog.emit()">
    {{ log?.details?.targetName }}
  </a>

  {{ " " + ((log?.action === "Delete" ? "WAS_DELETED_BY" : "WAS_MODIFIED_BY") | translate) + " " }}

  @if (!log?.staffId && log?.staffName === 'Everon Admin') {
    <strong>
      Everon Admin
    </strong>
  } @else {
    <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">{{ $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId) }}</a>
  }

</span>
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />

<span class="subtitle">
  {{ (log?.action === "Modify" ? "MODIFICATIONS" : "") | translate | uppercase }}
</span>

<div class="container">
  <!-- Group name -->
  @if (visibleFields | includes : 'groupName') {
    <span class="item-title">{{ "GROUP_NAME" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.groupName?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.groupName?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- Address -->
  @if (visibleFields | includes : 'address') {
    <span class="item-title">{{ "ADDRESS" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.address?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.address?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- Postal code -->
  @if (visibleFields | includes : 'postalCode') {
    <span class="item-title">{{ "POSTCODE" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.postalCode?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.postalCode?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- City -->
  @if (visibleFields | includes : 'city') {
    <span class="item-title">{{ "POSTOFFICE" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.city?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.city?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- Access mode -->
  @if (visibleFields | includes : 'accessModeTranslationCode') {
    <span class="item-title">{{ "ACCESS_MODE" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.accessModeTranslationCode?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.accessModeTranslationCode?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- Location -->
  @if (visibleFields | includes : 'location') {
    <span class="item-title">{{ "LOCATION" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ cameraGroupChanges?.location?.oldValue || "NONE" | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ cameraGroupChanges?.location?.newValue || "NONE" | translate }}
      </span>
    </div>
  }

  <!-- Cameras -->
  @if (visibleFields | some : 'addedCameras' : 'modifiedCameras' : 'removedCameras') {
    <p id="cameras-title" class="item-group-title">
      {{ "CAMERAS" | translate }}:
    </p>
    <div class="item-group-box">
      <!-- Added cameras -->
      @if (visibleFields | includes : 'addedCameras') {
        <span class="item-value d-flex align-items-center">
          {{ "ADDED" | translate }}:
          <span class="positive-highlight ml-4">
            @for (camera of cameraGroupChanges?.addedCameras; track camera; let isLast = $last) {
              <span>
                <strong>{{ camera.name + " (" + camera.id + ")" }}</strong>:
                {{ (camera | formatCameraDetails) }}
                @if (!isLast) {
                  <div class="mb-2"></div>
                }
              </span>
            }
          </span>
        </span>
      }
      <!-- Modified cameras -->
      @if (visibleFields | includes : 'modifiedCameras') {
        <span class="item-value d-flex align-items-center">
          {{ "MODIFIED" | translate }}:
          <span class="warning-highlight ml-4">
            @for (camera of cameraGroupChanges?.modifiedCameras; track camera; let isLast = $last) {
              <span>
                <strong>{{ camera.name + " (" + camera.id + ")" }}</strong>:
                {{ (camera | formatCameraDetails) }}
                @if (!isLast) {
                  <div class="mb-2"></div>
                }
              </span>
            }
          </span>
        </span>
      }
      <!-- Removed cameras -->
      @if (visibleFields | includes : 'removedCameras') {
        <span class="item-value d-flex align-items-center">
          {{ "REMOVED" | translate }}:
          <span class="negative-highlight line-through ml-4">
            {{ $safeNavigationMigration(cameraGroupChanges?.removedCameras) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    </div>
  }

  <!-- Receiver groups -->
  @if (visibleFields | some : 'addedReceiverGroups' : 'removedReceiverGroups') {
    <p id="receiver-groups-title" class="item-group-title">
      {{ "RECEIVER_TEAMS" | translate }}:
    </p>
    <div class="item-group-box">
      <!-- Added receiver groups -->
      @if (visibleFields | includes : 'addedReceiverGroups') {
        <span class="item-value d-flex align-items-center">
          {{ "ADDED" | translate }}:
          <span class="positive-highlight ml-4">
            {{ $safeNavigationMigration(cameraGroupChanges?.addedReceiverGroups) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
      <!-- Removed alert devices -->
      @if (visibleFields | includes : 'removedReceiverGroups') {
        <span class="item-value d-flex align-items-center">
          {{ "REMOVED" | translate }}:
          <span class="negative-highlight line-through ml-4">
            {{ $safeNavigationMigration(cameraGroupChanges?.removedReceiverGroups) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    </div>
  }

  <!-- Alert devices/connected devices -->
  @if (visibleFields | some : 'addedAlertDevices' : 'removedAlertDevices') {
    <p id="connected-devices-title" class="item-group-title">
      {{ "CONNECTED_DEVICES" | translate }}:
    </p>
    <div class="item-group-box">
      <!-- Added alert devices -->
      @if (visibleFields | includes : 'addedAlertDevices') {
        <span class="item-value d-flex align-items-center">
          {{ "ADDED" | translate }}:
          <span class="positive-highlight ml-4">
            {{ $safeNavigationMigration(cameraGroupChanges?.addedAlertDevices) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
      <!-- Removed alert devices -->
      @if (visibleFields | includes : 'removedAlertDevices') {
        <span class="item-value d-flex align-items-center">
          {{ "REMOVED" | translate }}:
          <span class="negative-highlight line-through ml-4">
            {{ $safeNavigationMigration(cameraGroupChanges?.removedAlertDevices) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    </div>
  }

  <!-- Event triggers -->
  @if (visibleFields | some : 'addedEventTriggers' : 'removedEventTriggers') {
    <p id="event-triggers-title" class="item-group-title">
      {{ "ACTIVATIONS" | translate }}:
    </p>
    <div class="item-group-box">
      <!-- Added event triggers grouped by deviceType -->
      @if (visibleFields | includes : 'addedEventTriggers') {
        <span class="item-value d-flex align-items-center">
          {{ "ADDED" | translate }}:
          <span class="positive-highlight ml-4">
            @for (group of groupEventTriggersByDeviceType($safeNavigationMigration(cameraGroupChanges?.addedEventTriggers)); track group) {
              <div>
                <strong>{{ getDeviceTypeName(group.deviceType) }}</strong>:
                <span>
                  {{ formatEventTriggers(group.triggers) }}
                </span>
              </div>
            }
          </span>
        </span>
      }
      <!-- Removed event triggers grouped by deviceType -->
      @if (visibleFields | includes : 'removedEventTriggers') {
        <span class="item-value d-flex align-items-center">
          {{ "REMOVED" | translate }}:
          <span class="negative-highlight line-through ml-4">
            @for (group of groupEventTriggersByDeviceType($safeNavigationMigration(cameraGroupChanges?.removedEventTriggers)); track group) {
              <div>
                <strong>{{ getDeviceTypeName(group.deviceType) }}</strong>:
                <span>
                  {{ formatEventTriggers(group.triggers) }}
                </span>
              </div>
            }
          </span>
        </span>
      }
    </div>
  }

  <!-- Visit by alarm type disabled -->
  @if (cameraGroupChanges?.visitByAlarmTypeDisabled && (visibleFields | includes : 'visitByAlarmTypeDisabled')) {
    <span class="item-title">{{ "ACTIVATIONS" | translate }}:</span>
    <div class="item-value">
      <span class="positive-highlight">
        {{ "ALL_ALERT_TYPES_SELECTED" | translate}}
      </span>
    </div>
  }

  <!-- Visit time -->
  @if (visibleFields | includes : 'visitTimeMinutes') {
    <span class="item-title">{{ "VISIT_TIME" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{
        cameraGroupChanges?.visitTimeMinutes?.oldValue
        ? cameraGroupChanges.visitTimeMinutes.oldValue + " " + ("MINUTES" | translate)
        : "NONE" | translate
        }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{
        cameraGroupChanges?.visitTimeMinutes?.newValue
        ? cameraGroupChanges.visitTimeMinutes.newValue + " " + ("MINUTES" | translate)
        : "NONE" | translate
        }}
      </span>
    </div>
  }

  <!-- Visit grace time -->
  @if (visibleFields | includes : 'graceTimeMinutes') {
    <span class="item-title">{{ "GRACE_TIME" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{
        cameraGroupChanges?.graceTimeMinutes?.oldValue
        ? cameraGroupChanges.graceTimeMinutes.oldValue + " " + ("MINUTES" | translate)
        : "NONE" | translate
        }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{
        cameraGroupChanges?.graceTimeMinutes?.newValue
        ? cameraGroupChanges.graceTimeMinutes.newValue + " " + ("MINUTES" | translate)
        : "NONE" | translate
        }}
      </span>
    </div>
  }

  <!-- Origon call -->
  @if (visibleFields | includes : 'origon') {
    <p class="item-group-title">
      {{ "ORIGON_CALL" | translate }}:
    </p>
    <div class="item-group-box">
      <!-- Added -->
      @if (!cameraGroupChanges?.origon?.oldValue && cameraGroupChanges?.origon?.newValue) {
        <span class="item-value d-flex align-items-center">
          {{ "ADDED" | translate }}:
          <span class="positive-highlight ml-4">
            {{ getDeviceName($safeNavigationMigration(cameraGroupChanges?.origon?.newValue)) }}
          </span>
        </span>
      }
      <!-- Modified -->
      @if (cameraGroupChanges?.origon?.oldValue && cameraGroupChanges?.origon?.newValue) {
        <span class="item-value d-flex align-items-center">
          {{ "MODIFIED" | translate }}:
          <span class="warning-highlight ml-4 d-flex align-items-center">
            <span class="line-through">
              {{ getDeviceName($safeNavigationMigration(cameraGroupChanges?.origon?.oldValue)) }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg mx-2"></i>
            <span>
              {{ getDeviceName($safeNavigationMigration(cameraGroupChanges?.origon?.newValue)) }}
            </span>
          </span>
        </span>
      }
      <!-- Removed -->
      @if (cameraGroupChanges?.origon?.oldValue && !cameraGroupChanges?.origon?.newValue) {
        <span class="item-value d-flex align-items-center">
          {{ "REMOVED" | translate }}:
          <span class="negative-highlight line-through ml-4">
            {{ getDeviceName($safeNavigationMigration(cameraGroupChanges?.origon?.oldValue)) }}
          </span>
        </span>
      }
    </div>
  }
</div>

<!-- Removed visits -->
@if (visibleFields | includes : 'removedVisits') {
  <div class="mt-2">
    <p class="subtitle">{{ "VISITS_REMOVED" | translate }}:</p>
    @for (visit of cameraGroupChanges?.removedVisits; track visit) {
      <div class="ml-3 mb-3 d-flex">
        <span>{{ "VISIT_DETAIL" | translate }}:</span>
        <div class="negative-highlight line-through" style="margin-left: 50px">
          <span>
            {{ (visit.startTime | weekday : language) + " " + (visit.startTime | moment : "LT") }}
          </span>
        </div>
        <div class="ml-3 negative-highlight line-through">
          <span>
            {{ ("DURATION" | translate) + ": " + visit.durationMinutes + " min" }}
          </span>
        </div>
        <div class="ml-3 negative-highlight line-through">
          <span>
            {{ ("EXTENSION_TIME" | translate) + ": " + visit.extendedVisitTimeMinutes + " min" }}
          </span>
        </div>
      </div>
    }
  </div>
}

@if (allFields.length > visibleFieldCount) {
  <div class="mt-4">
    <span id="shown-details-info">{{ ("SHOWN_ACTIVITY_DETAILS_INFO" | translate : visibleFieldCount) | uppercase }}.</span>
  </div>
}
